import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../components/HomePage.vue'
import GuidePage from '../views/GuidePage.vue'
import HistoryPage from '../views/HistoryPage.vue'
import StartAssessmentPage from '../views/StartAssessmentPage.vue'
import BasicInfoPage from '../views/BasicInfoPage.vue'
import QuestionnairePage from '../views/QuestionnairePage.vue'
import CalculatingPage from '../views/CalculatingPage.vue'

// 霍兰德测试结果页面
import HollandResultPage from '../views/HollandResultPage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/guide',
    name: 'Guide',
    component: GuidePage
  },
  {
    path: '/history',
    name: 'History',
    component: HistoryPage
  },
  {
    path: '/assessment/start',
    name: 'StartAssessment',
    component: StartAssessmentPage
  },
  // 霍兰德测试不需要选择类型，直接跳转到基本信息页
  {
    path: '/assessment/select-type',
    redirect: '/assessment/info'
  },
  {
    path: '/assessment/info',
    name: 'BasicInfo',
    component: BasicInfoPage
  },
  {
    path: '/assessment/questions',
    name: 'Questionnaire',
    component: QuestionnairePage
  },
  {
    path: '/assessment/calculating',
    name: 'Calculating',
    component: CalculatingPage
  },
  // 霍兰德测试结果页
  {
    path: '/result/:id',
    name: 'HollandResult',
    component: HollandResultPage
  },
  // 旧路径重定向
  {
    path: '/animal-result',
    redirect: '/'
  },
  {
    path: '/ayp-result',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

export default router

